export default "__VITE_ASSET__Dc5U5Ast__"